<template>
  <svg viewBox="0 0 125 49" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path
        fill="#5D5D5F"
        d="M.41 1.368h12.9l10.602 35.524L34.516 1.368h12.831v46.734h-7.969V11.228h-.945L27.965 46.21H19.86L9.325 11.228H8.312v36.874H.41V1.368M53.358 1.368h33.768v7.631H74.294v39.103h-7.97V9H53.359V1.368"
      />
      <path
        d="M111.776 23.655h13.17v23.637s-9.59 1.553-15.466 1.553c-14.453 0-18.572-8.644-18.572-24.177C90.908 8.324 95.433.625 109.21.625c7.091 0 15.735 1.891 15.735 1.891l-.202 6.889s-8.24-1.081-14.385-1.081c-8.915 0-11.279 3.985-11.279 16.344 0 12.02 1.891 16.478 11.076 16.478 3.174 0 6.889-.472 6.956-.472v-9.928h-5.335v-7.091"
        fill="#41789C"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "MtgLogo"
};
</script>
